import { Link } from 'react-router-dom';

import ApplicationFooter from '@frolight/components/ApplicationFooter';
import usePageTitle from '@frolight/hooks/usePageTitle';
import useLocalizedFormattedText from '@frolight/hooks/useLocalizedFormattedText';
import LocaleSelector from '@frolight/components/LocaleSelector';

const NotFoundPage = (props) => {
  const { lftext } = useLocalizedFormattedText();

  usePageTitle(lftext('pages.page_not_found.page_title'));
  
  const renderError = () => {
    let showError = false;
    let errorMessage = '';

    if (error) {
      switch (error.errorCode) {
        case 401:
          showError = true;
          errorMessage = lftext('pages.page_not_found.401_message');
        case 500:
          showError = true;
          errorMessage = lftext('pages.page_not_found.500_message');
          break;
        default:
          break;
      }
    }

    if (showError) {
      return (
        <div className="form__feedback">
          <p className="feedback_message  feedback_message--error">
            {lftext('pages.page_not_found.invalid_password')}
          </p>
        </div>
      );
    }
    return null;
  }

  return (
    <div className="simple_page">
      <div className="simple_page__inner">
        <LocaleSelector theme="dark" />
        <section className="panel  panel--huge">
          <div className="panel__header">
            <header className="small_application_header">
              <Link className="logo_link  logo_link--large" to="/">
                <img className="logo_link__img" src="images/frolight_logo.svg" alt="Frolight logo" />
              </Link>
            </header>
          </div>
          <div className="panel__content">
            <main>
              <div className="feedback_message  feedback_message--warning">
                  {lftext('pages.page_not_found.message')}
              </div>
            </main>
          </div>
        </section>
      </div>
      <div className="simple_page__footer">
        <ApplicationFooter compact={ false } />
      </div>
    </div>
  );
}

export default NotFoundPage;
